// extracted by mini-css-extract-plugin
export default {"titleArea":"TheSubpageTitle_titleArea_mo6Hl"};